import { React, useEffect, useRef, useContext, useState } from 'react';
import './form.css';
import { useNavigate, Link, useParams } from 'react-router-dom';
import SocialContext from '../../context/SocialContext';
import Alertjs from '../../components/alert/Alert';
import { CircularProgress } from '@material-ui/core';
import Topbar from '../../components/topbar/Topbar';
import axiosInstance from '../../config';

import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';

export default function ForgotPassword() {
    const { id, token } = useParams();

    const navigate = useNavigate();
    const { showalert, setshowalert, setalertType, setalertmessage, scrolltoTopfun } = useContext(SocialContext);

    useEffect(() => {
        if (localStorage.getItem('currentUID')) {
            navigate('/');
        }
        scrolltoTopfun();
        window.document.title = 'SocialHub - Reset Password';
    }, [])

    const password = useRef();
    const confirmpassword = useRef();
    const [isfetching, setisfetching] = useState(false);
    const [message, setmessage] = useState(false);

    // check if password reset link exist or correct 
    const fetchlink = async () => {
        const response = await axiosInstance.get('api/auth/forgotpassword/' + id + '/' + token);
        if (response.data.status == 201) {
            console.log("user valid")
        } else {
            navigate("/linkexpire")
        }
    }

    useEffect(() => {
        fetchlink();
    }, [])

    const sendresetpassword = async () => {
        setisfetching(true);
        fetchlink();
        const response = await axiosInstance.post(`api/auth/${id}/${token}`, { password: password.current.value });
        if (response.data.status == 201) {
            password.current.value = "";
            confirmpassword.current.value = "";
            setmessage(true);
            setshowalert(true);
            setalertType('success');
            setalertmessage("Password reset successfully");
            setTimeout(() => {
                setshowalert(false);
            }, 2000);
        } else {
            password.current.value = "";
            confirmpassword.current.value = "";
            setshowalert(true);
            setalertType('error');
            setalertmessage("! Time Expired reset again");
            setTimeout(() => {
                setshowalert(false);
            }, 2000);
        }
        setisfetching(false);
        fetchlink();
    }

    // function for submiting a form 
    const onsubmitfun = (event) => {
        event.preventDefault();
        if (password.current.value !== confirmpassword.current.value) {
            setshowalert(true);
            setalertType('warning');
            setalertmessage("Opps! Password do not match");
            setTimeout(() => {
                setshowalert(false);
            }, 2000);
        } else {
            sendresetpassword();
        }
    }

    const onclickfun = () => {
        if (password.current.value == "" || confirmpassword.current.value == "") {
            setshowalert(true);
            setalertType('warning');
            setalertmessage("Please enter user credentials and try again..");
            setTimeout(() => {
                setshowalert(false);
            }, 2000);
        }
    }

    const fun = () => {
        confirmpassword.current.setCustomValidity("Passwords don't match!");
        console.log(password.current.value, confirmpassword.current.value);
    }

    const [visible1, setvisible1] = useState(false);
    const [visible2, setvisible2] = useState(false);
    const [inputType1, setinputType1] = useState('password');
    const [inputType2, setinputType2] = useState('password');
    const toggleVisiblefun = (number) => {
        if (number == 1) {
            setvisible1(!visible1);
            if (inputType1 == 'password') {
                setinputType1('text')
            } else {
                setinputType1('password')
            }
        } else {
            setvisible2(!visible2);
            if (inputType2 == 'password') {
                setinputType2('text')
            } else {
                setinputType2('password')
            }
        }
    }

    return (
        <>
            <Topbar />
            {showalert ? <div style={{ height: '48px', 'position': 'sticky', 'top': '50px', 'zIndex': '2' }}>
                <Alertjs />
            </div> : ""}

            <div className="back">
                <div className='formbody'>
                    <div className="sign-up-form">
                        <h1> Enter New Password</h1>
                        {message ? <p style={{ color: 'green', fontWeight: 'bold', marginBottom: '15px' }}>Password changed Successfully</p> : ''}
                        <form onSubmit={onsubmitfun}>
                            <div className='passworddiv' style={{ 'marginBottom': '15px' }}><input autoComplete='off' style={{ border: 'none', margin: '0px' }} ref={password} name='password' required minLength={6} maxLength={12} type={inputType1} className='input-box' placeholder='Password' />{visible1 ? <VisibilityIcon style={{ 'marginRight': '10px', opacity: '0.6' }} onClick={() => { toggleVisiblefun(1) }} /> : <VisibilityOffIcon style={{ 'marginRight': '10px', opacity: '0.6' }} onClick={() => { toggleVisiblefun(1) }} />}</div>
                            <div className='passworddiv' style={{ 'marginBottom': '15px' }}><input autoComplete='off' style={{ border: 'none', margin: '0px' }} ref={confirmpassword} name='confpassword' required minLength={6} maxLength={12} type={inputType2} className='input-box' placeholder='Conform Password' />{visible2 ? <VisibilityIcon style={{ 'marginRight': '10px', opacity: '0.6' }} onClick={() => { toggleVisiblefun(2) }} /> : <VisibilityOffIcon style={{ 'marginRight': '10px', opacity: '0.6' }} onClick={() => { toggleVisiblefun(2) }} />}</div>
                            <button type='submit' onClick={onclickfun} className='signup-btn formbutton'>{isfetching ? <CircularProgress color="white" size="17px" /> : "Update"}</button>
                        </form>
                    </div>
                </div>
                <div className="copyright" style={{ 'position': 'fixed', 'bottom': '1px', 'width': '100%' }}>
                    <p style={{ 'textAlign': 'center', opacity: '0.9', 'width': '100%' }}>Copyright ©2022-Alok.info | All rights reserved</p>
                </div>
            </div>
        </>
    );
}